import React, { FC, useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { IonContent, useIonViewWillEnter, useIonRouter, useIonViewWillLeave, useIonViewDidEnter } from '@ionic/react'
import { cartMobx, restaurantCenter, discountMobx } from 'restaurant'
import { decorationMobx, memberMobx, timePickMobx, payPlanMobx, storeMobx, checkoutMobx, deliveryMobx, eatTypeStatusMobx, queueOrderingMobx, orderLiveMobx, payRechargeMobx, thirdPartyMobx } from '@mobxStore'
import { handleEleScrollTo, useHistoryNew } from '@utils'
import { classNames, useThrottle } from '@dt/fe-utils'
import { OpenCardSlides } from '@cps'
import { QueueBar } from '@pages/menu/components'
import { CheckoutContact, CheckoutAddress, CartResultPrice, DiscountOrderSwapBuyTip, PayAndRechargeTip, EatTypeSwitchBar } from '../../component'
import PayAndRechargeList from '../../component/Pay/PayAndRechargeList'
import './index.scss'

interface IProps { }

const CartCheck: FC<IProps> = (props) => {
  const history = useHistoryNew()
  const ionicRoute = useIonRouter()
  const [showDiscountOrderSwapBuyTip, setShowDiscountOrderSwapBuyTip] = useState(false)
  const [hasPayAndRechargeList, setHasPayAndRechargeList] = useState(false)
  const [showPayAndRechargeTip, setShowPayAndRechargeTip] = useState(false)

  const isShowPayAndRecharge = !cartMobx.info?.payMode || (cartMobx.info?.payMode && cartMobx.ordersId && (storeMobx.storeSceneConfig?.openAfterPayCustomerPay || !storeMobx.storeSceneConfig?.payMode)) || cartMobx.posOrderPay

  const calcOrderSwapBuyPos = () => {
    const _clientHeight = (document.querySelector('#CheckoutContent') as any)?.clientHeight
    const _offsetTop = (document.querySelector('#DiscountOrderSwapBuyWrapper') as any)?.offsetTop
    if (history.getPrevState() === '/menu' && _clientHeight < _offsetTop + 10) {
      setShowDiscountOrderSwapBuyTip(true)
    } else {
      setShowDiscountOrderSwapBuyTip(false)
    }
  }

  const calcPayAndRecharge = (e?: any) => {
    const _scrollTop = e?.detail?.scrollTop
    const _clientHeight = (document.querySelector('#CheckoutContent') as any)?.clientHeight
    const _offsetTop = (document.querySelector('#PayAndRechargeList') as any)?.offsetTop
    if (!payRechargeMobx.memberCardCanFullpay && isShowPayAndRecharge) {
      if (e) {
        if (history.getPrevState() === '/menu' && _scrollTop + _clientHeight - 40 < _offsetTop && showPayAndRechargeTip) {
          setShowPayAndRechargeTip(true)
        } else {
          setShowPayAndRechargeTip(false)
        }
      } else {
        setShowPayAndRechargeTip(true)
      }
    } else {
      setShowPayAndRechargeTip(false)
    }
  }

  const handleScrollToPayAndRechargeList = () => {
    const _offsetTop = (document.querySelector('#PayAndRechargeList') as any)?.offsetTop
    handleEleScrollTo?.({
      selector: '#CheckoutContent',
      y: _offsetTop || 0,
    })
    setShowPayAndRechargeTip(false)
  }

  const handleScroll = useThrottle(function (e: any) {
    const scrollTop = typeof e === 'number' ? e : (e.detail?.scrollTop || 0)
    if (scrollTop > 0) {
      setShowDiscountOrderSwapBuyTip(false)
    }
    calcPayAndRecharge(e)
  }, 100, [showPayAndRechargeTip])

  useIonViewWillEnter(() => {
    // if (!cartMobx.info.payMode && !cartMobx.cartItems.length) {
    //   history.getPrevState() ? history.goBack() : history.replace('/menu')
    // }
    if (decorationMobx.tabBarVisible) {
      decorationMobx.setTabBarVisible(false)
      document.querySelector('ion-tab-bar')?.classList.add('hide')
    }
    // 来自于订单页
    payPlanMobx.beginCalc()
    if (decorationMobx.tabBarVisible) {
      decorationMobx.setTabBarVisible(false)
      document.querySelector('ion-tab-bar')?.classList.add('hide')
    }
    if (cartMobx.info.payMode) {
      checkoutMobx.setShowDetail(true)
    }
  })

  useIonViewWillLeave(() => {
    restaurantCenter.off(orderLiveMobx.cartItemsChangedHandler)
    cartMobx.setIsMixture(true)
    payPlanMobx.endCalc()
  })

  useIonViewDidEnter(() => {
    calcOrderSwapBuyPos()
    calcPayAndRecharge()
  })

  useEffect(() => {
    if (ionicRoute.routeInfo.lastPathname === '/checkout' && ionicRoute.routeInfo.routeDirection === 'back') {
      ionicRoute.routeInfo.pushedByRoute = '/checkout'
    }
  }, [ionicRoute])

  useEffect(() => {
    if (deliveryMobx.isDelivery) {
    } else {
      if (deliveryMobx.address) {
        deliveryMobx.resetAddress()
      }
    }
  }, [deliveryMobx.isDelivery, memberMobx.memberInfo, storeMobx.info.storeId, cartMobx.info])

  return (
    <>
      <IonContent
        id='CheckoutContent'
        className='checkout-content'
        scrollEvents
        onIonScroll={(e) => { handleScroll(e) }}
      >
        <div className={classNames('cart-page-content')}>
          {
            !cartMobx.needPack && !!queueOrderingMobx.inPreQueueOrdering && <QueueBar scene='checkout' />
          }
          <header>
            {/* {Config.codeType === 'table' && <LoginGuide isLogin={memberMobx.isLogin} />} */}
            <EatTypeSwitchBar />
            {cartMobx.info.eatType === 'delivery' ? <CheckoutAddress /> : <CheckoutContact />}
          </header>
          {Config.codeType !== 'table' && <div className='cart-split'></div>}
          {Config.codeType !== 'table' && <div style={{ paddingTop: '16px' }}></div>}
          {props.children}
          {
            !cartMobx.needPack && <CartResultPrice />
          }
        </div>
        {
          !cartMobx.needPack && !payRechargeMobx.memberCardCanFullpay && isShowPayAndRecharge && !thirdPartyMobx.checkCoupons.length && <PayAndRechargeList onChange={(val) => setHasPayAndRechargeList(val)} />
        }
        {
          !!memberMobx.noPurchasedCards?.length && <OpenCardSlides type='meal' noPurchasedCardMap={discountMobx.discountResult.noPurchasedCardMap} />
        }
        {
          !cartMobx.needPack && <DiscountOrderSwapBuyTip show={showDiscountOrderSwapBuyTip} addBottom={showPayAndRechargeTip ? 40 : 0} />
        }
        {
          !cartMobx.needPack && !thirdPartyMobx.checkCoupons.length && <PayAndRechargeTip show={showPayAndRechargeTip && hasPayAndRechargeList} onClick={handleScrollToPayAndRechargeList} />
        }
      </IonContent>
    </>
  )
}

export default observer(CartCheck)
